const EVENT_METADATA_TYPES = {
  USER: 'USER',
  LOCATION_TYPE_CATEGORY: 'LOCATION_TYPE_CATEGORY',
  LOCATION_TYPE: 'LOCATION_TYPE',
  INGREDIENT_SPECIAL_CASE: 'INGREDIENT_SPECIAL_CASE',
  INGREDIENT: 'INGREDIENT',
  INGREDIENT_COMMON_NEGATIVE_SYNONYM_PHRASE:
    'INGREDIENT_COMMON_NEGATIVE_SYNONYM_PHRASE',
  DICTIONARY_WORD: 'DICTIONARY_WORD',
  DISH_TYPE: 'DISH_TYPE',
  DIET: 'DIET',
  DIET_CATEGORY: 'DIET_CATEGORY',
  CUISINE_TYPE: 'CUISINE_TYPE',
  AWARD: 'AWARD',
  COURSE_TYPE: 'COURSE_TYPE',
  ALLERGEN: 'ALLERGEN',
  CHALLENGE: 'CHALLENGE',
  FOOD_MOOD: 'FOOD_MOOD',
}

export default EVENT_METADATA_TYPES
